import React, { FC } from 'react';
import type { Event } from '@mb/types';
import { EventItem } from '../EventItem/EventItem';

interface EventsGridProps {
  events: Event[];
  title: string;
  isFeatured?: boolean;
}

export const EventsGrid: FC<EventsGridProps> = ({
  events,
  title,
  isFeatured,
}) => {
  if (events.length === 0) return null;
  return (
    <div className="flex flex-col gap-6">
      <div className="flex justify-between items-center p-0">
        <h2 className="font-bold text-lgg">{title}</h2>
      </div>
      <ul className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {events.map((event, index) => (
          <EventItem
            key={`event-${index}`}
            event={event}
            index={index}
            isFeatured={isFeatured}
            inView={true}
          />
        ))}
      </ul>
    </div>
  );
};
